import { JSX } from 'react';
import classNames from 'classnames';
import { t, GamificationNotificationType } from '@bg-shared';
import { NotificationTranslationKey } from '../enums';
import { NotificationIcon } from '../NotificationIcon';
import classes from './Message.module.scss';

interface IProps {
    id: string;
    title: string;
    type: GamificationNotificationType;
    date: string;
    onClick(): void;
}

export const Message = (props: IProps): JSX.Element => {
    const headKey =
        props.type === GamificationNotificationType.CHALLENGE
            ? NotificationTranslationKey.CHALLENGE
            : NotificationTranslationKey.EMAIL;

    return (
        <li
            className={classNames(classes.message, classes[props.type])}
            data-qa={`area-notification-${props.id}`}
        >
            <div
                role="button"
                key={props.id}
                className={classes.link}
                data-qa={`button-notification-${props.id}`}
                onClick={props.onClick}
            >
                <span className={classes.head} data-qa="text-notification-head">
                    <NotificationIcon type={props.type} className={classes.icon} />
                    {t.gamification(headKey)}
                </span>
                <span className={classes.title} data-qa="text-notification-title">
                    {props.title}
                </span>
                <span className={classes.date} data-qa="text-notification-date">
                    {props.date}
                </span>
            </div>
        </li>
    );
};
